
import { defineComponent } from 'vue'
// import AppButton from '../atoms/AppButton.vue'
import ButtonIcon from './ButtonIcon.vue'

export default defineComponent({
  components: {
    // AppButton,
    ButtonIcon
  },
  props: {
    pid: {
      type: Number,
      required: true
    },
    bid: {
      type: [String, Boolean],
      required: true
    },
    cid: {
      type: [String, Boolean],
      required: true
    },
    type: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    },
    autoRemove: {
      type: Number
    }
  },
  setup (props, context) {
    let timeObj: any = null
    const query = {
      pid: props.pid,
      bid: props.bid,
      cid: props.cid
    }

    const onRemove = () => {
      context.emit('remove', query)
      clearTimeout(timeObj)
    }

    const onReset = () => {
      context.emit('reset', query)
      clearTimeout(timeObj)
    }

    if (props.autoRemove) {
      timeObj = setTimeout(onRemove, props.autoRemove)
    }

    return {
      onRemove,
      onReset,
    }
  }
})
